import { Loader } from '@snowball-tech/fractal/dist/src/components/Loader'

import { useEffect } from 'react'

import omit from 'lodash/fp/omit'

import { LoremPicsum } from '../../api/LoremPicsum'
import useSearch from '../../hooks/useSearch'
import { GalleryImage } from '../../types'
import DisplayError from '../DisplayError'
import Gallery from './Gallery'

type Props = {
  page?: number
  onPick?: (image: GalleryImage) => void
}
export default function LoremPicsumGallery({ onPick, page = 1 }: Props) {
  const loremPicsum = new LoremPicsum(undefined, { maxResults: 20 })

  const [, setPage, images] = useSearch<GalleryImage>(
    async (pageToLoad, abortSignal) => {
      const results =
        (await loremPicsum.list(
          { page: Number.parseInt(pageToLoad, 10) },
          abortSignal,
        )) ?? []

      return results.map((result) => ({
        alt: result.description || '',
        src: result.url,
        ...omit(['url', 'description'], result),
      }))
    },
  )

  useEffect(() => {
    setPage(String(page))
  }, [page, setPage])

  return (
    <>
      {images.loading && <Loader />}
      {!images.loading && images.error && <DisplayError error={images.error} />}

      {!images.loading && !images.error && (
        <Gallery
          images={images.result || []}
          spacing={16}
          targetRowHeight={150}
          onImageClick={({ photo: image }) => onPick?.(image)}
        />
      )}
    </>
  )
}
